export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6884.3d858eba.jpg";